import { useNavigate } from 'react-router';

import warningIcon from '../../../assets/images/warningIcon.svg';
import { closePopup } from '../../../store/slices/popupSlice';
import { useAppDispatch } from '../../../store/store';
import OutlineButton from '../../ui/buttons/outlineButton/OutlineButton';
import RedButton from '../../ui/buttons/redButton/RedButton';
import styles from './styles/styles.module.css';

function ExitOrderPopup() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleClosePopup = () => {
    dispatch(closePopup());
  };

  const handleNavigate = () => {
    dispatch(closePopup());
    sessionStorage.removeItem('order');
    navigate('/orders');
  };

  return (
    <div className={styles.exitOrderPopupWrapper}>
      <button
        className={styles.closePopupButton}
        onClick={handleClosePopup}
        aria-label="Закрыть"
      />
      <div className={styles.exitOrderTextWrapper}>
        <img src={warningIcon} alt="иконка предупреждение" />
        <h2 className={styles.exitOrderTitle}>Выйти из заказа без сохранения</h2>
        <h3 className={styles.exitOrderSubTitle}>
          Вы уверены что хотите выйти не сохранив изменения?
        </h3>
      </div>
      <div className={styles.exitOrderPopupButtons}>
        <OutlineButton text="Нет" onClick={handleClosePopup} width={148} height={50} />
        <RedButton text="Да" onClick={handleNavigate} width={148} height={50} />
      </div>
    </div>
  );
}

export default ExitOrderPopup;
